module.exports = __webpack_public_path__ + "static/media/mic.95bc68ee.svg";